import type { EduDemoDataset } from '../../explore_seeds/edu/eduDemoTypes'

const cachedDatasets = new Map<string, EduDemoDataset>()

export async function getEduDemoDataset(
  workspaceId: string,
  today: Date = new Date(),
): Promise<EduDemoDataset | null> {
  let dataset = cachedDatasets.get(workspaceId)
  if (!dataset) {
    if (workspaceId === 'school-demo') {
      const mod = await import('../../explore_seeds/edu/schoolDemo')
      dataset = mod.buildSchoolDemo(today)
    } else if (workspaceId === 'coaching-demo') {
      const mod = await import('../../explore_seeds/edu/coachingDemo')
      dataset = mod.buildCoachingDemo(today)
    } else if (workspaceId === 'sports-academy-demo') {
      const mod = await import('../../explore_seeds/edu/sportsAcademyDemo')
      dataset = mod.buildSportsAcademyDemo(today)
    } else {
      return null
    }
    cachedDatasets.set(workspaceId, dataset)
  }
  return dataset
}

export function getEduDemoDatasetSync(workspaceId: string): EduDemoDataset | null {
  return cachedDatasets.get(workspaceId) ?? null
}

export async function getSchoolDemoDataset(today: Date = new Date()): Promise<EduDemoDataset> {
  const d = await getEduDemoDataset('school-demo', today)
  return d!
}

export function getSchoolDemoDatasetSync(): EduDemoDataset | null {
  return getEduDemoDatasetSync('school-demo')
}

export function setEduDemoDatasetForTests(
  workspaceId: string,
  dataset: EduDemoDataset | null,
): void {
  if (dataset) {
    cachedDatasets.set(workspaceId, dataset)
  } else {
    cachedDatasets.delete(workspaceId)
  }
}

export function setSchoolDemoDatasetForTests(dataset: EduDemoDataset | null): void {
  setEduDemoDatasetForTests('school-demo', dataset)
}

export function clearEduDemoDatasetsForTests(): void {
  cachedDatasets.clear()
}
